<template>
  <div class="crm-customer-container">
    <HomeHeader />
    <div class="w1200" id="main_content">
      <div class="crm-customer-content">

        <div class="content-header">
          <h1>CRM 客户关系管理</h1>
          <!-- <div class="header-actions">
            <el-button type="primary" :loading="syncLoading" @click="handleSync">
              同步客户关系
            </el-button>
            <el-button type="warning" :loading="matchLoading" @click="handleMatch">
              代理多公司匹配
            </el-button>
          </div> -->
        </div>

        <!-- 统计条 -->
        <!-- <div class="stats-bar" v-loading="statsLoading">
          <div class="stat-item">
            <span class="stat-label">有效客户</span>
            <span class="stat-value">{{ stats.total_enabled || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">疑似代理网点</span>
            <span class="stat-value">{{ stats.agency_sites || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">代理组</span>
            <span class="stat-value">{{ stats.agency_groups || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">累计展示次数</span>
            <span class="stat-value">{{ stats.total_views || 0 }}</span>
          </div>
          <div class="stat-item" v-if="stats.confidence_stats">
            <span class="stat-label">可信度(低/中/高)</span>
            <span class="stat-value">
              {{ stats.confidence_stats.low }}/{{ stats.confidence_stats.medium }}/{{ stats.confidence_stats.high }}
            </span>
          </div>
        </div> -->

        <!-- 筛选区 -->
        <div class="filter-bar">
          <el-select v-model="filters.province" placeholder="省" clearable filterable
                     @change="onProvinceChange" style="width: 140px">
            <el-option v-for="p in regions.provinces" :key="p" :label="p" :value="p" />
          </el-select>
          <el-select v-model="filters.city" placeholder="市" clearable filterable
                     @change="onCityChange" style="width: 120px">
            <el-option v-for="c in cityOptions" :key="c" :label="c" :value="c" />
          </el-select>
          <el-select v-model="filters.district" placeholder="区县" clearable filterable
                     style="width: 120px">
            <el-option v-for="d in districtOptions" :key="d" :label="d" :value="d" />
          </el-select>
          <el-select v-model="filters.company_id" placeholder="物流公司" clearable
                     style="width: 120px">
            <el-option v-for="c in companyOptions" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
          <el-select v-model="filters.has_remark" placeholder="备注状态" clearable
                     style="width: 120px">
            <el-option label="已备注" value="yes" />
            <el-option label="未备注" value="no" />
          </el-select>
          <el-input v-model="filters.keyword" placeholder="网点/负责人/电话"
                    clearable style="width: 150px" @keyup.enter="fetchList" />
          <!-- <el-checkbox v-model="filters.only_agency">仅看代理</el-checkbox>
          <el-checkbox v-model="filters.include_disabled">含失效</el-checkbox> -->
          <el-checkbox v-model="showRemarkColumns">显示备注列</el-checkbox>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </div>

        <!-- 列表 -->
        <div class="table-wrapper">
          <el-table :data="tableData" v-loading="listLoading" border stripe
                    height="100%" row-key="id">
            <el-table-column prop="site_name" label="网点名称" min-width="160" show-overflow-tooltip />
            <el-table-column prop="manager_name" label="负责人" width="100" show-overflow-tooltip />
            <el-table-column label="联系电话" min-width="180">
              <template #default="{ row }">
                <div v-for="(p, i) in (row.contact_phones || [])" :key="i" class="phone-line">{{ p }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="company_name" label="物流公司" width="110" />
            <el-table-column label="地区" min-width="160" show-overflow-tooltip>
              <template #default="{ row }">
                {{ [row.province, row.city, row.district, row.town].filter(Boolean).join(' ') }}
              </template>
            </el-table-column>
            <el-table-column label="多网点" width="110">
              <template #default="{ row }">
                <el-tag v-if="row.agency_group_id > 0" :type="confidenceTag(row.agency_confidence)">
                  {{ confidenceText(row.agency_confidence) }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="showRemarkColumns" prop="remark1" label="电联前备注" min-width="160" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.remark1 || '-' }}
              </template>
            </el-table-column>
            <el-table-column v-if="showRemarkColumns" prop="remark2" label="电联后备注" min-width="160" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.remark2 || '-' }}
              </template>
            </el-table-column>
            <el-table-column v-if="showRemarkColumns" prop="remark3" label="其他备注" min-width="160" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.remark3 || '-' }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="view_count" label="展示次数" width="90" align="center" /> -->
            <el-table-column label="操作" width="100" fixed="right">
              <template #default="{ row }">
                <el-button type="primary" link @click="openDetail(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination
            v-model:current-page="filters.page"
            v-model:page-size="filters.page_size"
            :page-sizes="[20, 50, 100, 200]"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="fetchList"
            @current-change="fetchList"
          />
        </div>
      </div>
    </div>

    <!-- 详情抽屉 -->
    <el-drawer v-model="detailVisible" title="客户网点详情" size="55%" :destroy-on-close="true">
      <div v-loading="detailLoading">
        <template v-if="detail">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="网点名称">{{ detail.site_name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="物流公司">{{ detail.company_name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="负责人">{{ detail.manager_name || '-' }}</el-descriptions-item>
            <!-- <el-descriptions-item label="展示次数">{{ detail.view_count }}</el-descriptions-item> -->
            <el-descriptions-item label="联系电话" :span="2">
              <div v-for="(p, i) in (detail.contact_phones || [])" :key="i">{{ p }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="经纬度">
              {{ detail.longitude || '-' }}, {{ detail.latitude || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="地区">
              {{ [detail.province, detail.city, detail.district, detail.town].filter(Boolean).join(' ') || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="地址" :span="2">{{ detail.address || '-' }}</el-descriptions-item>
            <el-descriptions-item label="多网点标记">
              <el-tag v-if="detail.agency_group_id > 0" :type="confidenceTag(detail.agency_confidence)">
                组{{ detail.agency_group_id }} - {{ confidenceText(detail.agency_confidence) }}
              </el-tag>
              <span v-else>无</span>
            </el-descriptions-item>
            <el-descriptions-item label="最近同步">{{ formatTime(detail.last_sync_time) }}</el-descriptions-item>
          </el-descriptions>

          <!-- 关联代理网点 -->
          <div class="section-title" v-if="detail.related_agency_sites && detail.related_agency_sites.length">
            关联的多网点
          </div>
          <el-table v-if="detail.related_agency_sites && detail.related_agency_sites.length"
                    :data="detail.related_agency_sites" border size="small" style="margin-top: 8px">
            <el-table-column prop="company_name" label="物流公司" width="110" />
            <el-table-column prop="site_name" label="网点名称" min-width="140" show-overflow-tooltip />
            <el-table-column prop="manager_name" label="负责人" width="90" />
            <el-table-column label="联系电话" min-width="160">
              <template #default="{ row }">
                <div v-for="(p, i) in (row.contact_phones || [])" :key="i">{{ p }}</div>
              </template>
            </el-table-column>
            <el-table-column label="可信度" width="80">
              <template #default="{ row }">
                <el-tag size="small" :type="confidenceTag(row.agency_confidence)">
                  {{ confidenceText(row.agency_confidence) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark1" label="电联前备注" min-width="140" show-overflow-tooltip>
              <template #default="{ row }">{{ row.remark1 || '-' }}</template>
            </el-table-column>
            <el-table-column prop="remark2" label="电联后备注" min-width="140" show-overflow-tooltip>
              <template #default="{ row }">{{ row.remark2 || '-' }}</template>
            </el-table-column>
            <el-table-column prop="remark3" label="其他备注" min-width="140" show-overflow-tooltip>
              <template #default="{ row }">{{ row.remark3 || '-' }}</template>
            </el-table-column>
          </el-table>

          <!-- 备注区 -->
          <div class="section-title">备注信息</div>
          <el-form label-position="top" class="remark-form">
            <el-form-item label="电联前备注">
              <el-input v-model="remarkForm.remark1" type="textarea" :rows="1" />
            </el-form-item>
            <el-form-item label="电联后备注">
              <el-input v-model="remarkForm.remark2" type="textarea" :rows="1" />
            </el-form-item>
            <el-form-item label="其他备注">
              <el-input v-model="remarkForm.remark3" type="textarea" :rows="1" />
            </el-form-item>
            <el-button type="primary" :loading="remarkSaving" @click="saveRemarks">保存备注</el-button>
          </el-form>
        </template>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import HomeHeader from '../components/HomeHeader.vue'
import { postWlApi, getWlApi } from '@utils/api_v1.js'

// 已知物流公司，与后端 crm.config.COMPANY_DEST_SITE_MAP 一致
const companyOptions = [
  { id: 1, name: '韵达' },
  { id: 2, name: '安能' },
  { id: 3, name: '中通' },
  { id: 5, name: '顺心捷达' },
  { id: 6, name: '百世' },
  { id: 7, name: '融辉' },
]

const filters = reactive({
  page: 1,
  page_size: 50,
  province: '',
  city: '',
  district: '',
  company_id: '',
  has_remark: '',
  keyword: '',
  only_agency: false,
  include_disabled: false,
})

const showRemarkColumns = ref(false)

const regions = reactive({ provinces: [], cities: [], districts: [], city_map: {}, district_map: {} })

// 省市区县联动选项
const cityOptions = computed(() => {
  if (filters.province) {
    return regions.city_map[filters.province] || []
  }
  return regions.cities
})

const districtOptions = computed(() => {
  if (filters.city) {
    return regions.district_map[filters.city] || []
  }
  if (filters.province) {
    const cities = regions.city_map[filters.province] || []
    const set = new Set()
    cities.forEach(city => {
      (regions.district_map[city] || []).forEach(d => set.add(d))
    })
    return Array.from(set)
  }
  return regions.districts
})

const tableData = ref([])
const total = ref(0)
const listLoading = ref(false)

const stats = ref({})
const statsLoading = ref(false)

const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref(null)
const remarkForm = reactive({ remark1: '', remark2: '', remark3: '' })
const remarkSaving = ref(false)

const syncLoading = ref(false)
const matchLoading = ref(false)

const confidenceText = (c) => {
  if (c === 'high') return '高'
  if (c === 'medium') return '中'
  if (c === 'low') return '低'
  return '-'
}
const confidenceTag = (c) => {
  if (c === 'high') return 'danger'
  if (c === 'medium') return 'warning'
  if (c === 'low') return 'info'
  return 'info'
}

const formatTime = (t) => {
  if (!t) return '-'
  return new Date(t).toLocaleString('zh-CN')
}

const fetchRegions = async () => {
  try {
    const res = await getWlApi('/crm/customer/regions')
    if (res && res.code === 0 && res.data) {
      regions.provinces = res.data.provinces || []
      regions.cities = res.data.cities || []
      regions.districts = res.data.districts || []
      regions.city_map = res.data.city_map || {}
      regions.district_map = res.data.district_map || {}
    }
  } catch (e) {
    console.error('获取地区失败', e)
  }
}

const fetchStats = async () => {
  statsLoading.value = true
  try {
    const res = await getWlApi('/crm/customer/stats')
    if (res && res.code === 0) {
      stats.value = res.data || {}
    }
  } catch (e) {
    console.error('获取统计失败', e)
  } finally {
    statsLoading.value = false
  }
}

const fetchList = async () => {
  listLoading.value = true
  try {
    const res = await postWlApi('/crm/customer/list', { ...filters })
    if (res && res.code === 0 && res.data) {
      tableData.value = res.data.list || []
      total.value = res.data.total || 0
    } else {
      ElMessage.error(res?.message || '查询失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('查询失败')
  } finally {
    listLoading.value = false
  }
}

const onProvinceChange = () => {
  // 选择省份后重置市/区县
  filters.city = ''
  filters.district = ''
}

const onCityChange = () => {
  // 选择市后重置区县
  filters.district = ''
}

const resetFilters = () => {
  filters.page = 1
  filters.province = ''
  filters.city = ''
  filters.district = ''
  filters.company_id = ''
  filters.has_remark = ''
  filters.keyword = ''
  filters.only_agency = false
  filters.include_disabled = false
  fetchList()
}

const openDetail = async (row) => {
  detailVisible.value = true
  detailLoading.value = true
  detail.value = null
  try {
    const res = await postWlApi('/crm/customer/detail', { id: row.id })
    if (res && res.code === 0 && res.data) {
      detail.value = res.data
      remarkForm.remark1 = res.data.remark1 || ''
      remarkForm.remark2 = res.data.remark2 || ''
      remarkForm.remark3 = res.data.remark3 || ''
      // 同步更新列表中的展示次数
      row.view_count = res.data.view_count
    } else {
      ElMessage.error(res?.message || '获取详情失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('获取详情失败')
  } finally {
    detailLoading.value = false
  }
}

const saveRemarks = async () => {
  if (!detail.value) return
  remarkSaving.value = true
  try {
    const res = await postWlApi('/crm/customer/remark', {
      id: detail.value.id,
      remark1: remarkForm.remark1,
      remark2: remarkForm.remark2,
      remark3: remarkForm.remark3,
    })
    if (res && res.code === 0) {
      ElMessage.success('备注保存成功')
    } else {
      ElMessage.error(res?.message || '保存失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('保存失败')
  } finally {
    remarkSaving.value = false
  }
}

const handleSync = async () => {
  try {
    await ElMessageBox.confirm(
      '将根据已查询成功的网点结果提炼并同步客户关系信息，可能耗时较长，是否继续？',
      '同步确认',
      { type: 'warning' }
    )
  } catch {
    return
  }
  syncLoading.value = true
  try {
    const res = await postWlApi('/crm/customer/sync', {})
    if (res && res.code === 0) {
      ElMessage.success('同步完成')
      fetchStats()
      fetchList()
    } else {
      ElMessage.error(res?.message || '同步失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('同步失败')
  } finally {
    syncLoading.value = false
  }
}

const handleMatch = async () => {
  matchLoading.value = true
  try {
    const res = await postWlApi('/crm/customer/match_agency', {})
    if (res && res.code === 0) {
      ElMessage.success(`匹配完成：${res.data?.agency_sites || 0} 个网点疑似代理，共 ${res.data?.agency_groups || 0} 组`)
      fetchStats()
      fetchList()
    } else {
      ElMessage.error(res?.message || '匹配失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('匹配失败')
  } finally {
    matchLoading.value = false
  }
}

onMounted(() => {
  fetchRegions()
  fetchStats()
  fetchList()
})
</script>

<style scoped>
.crm-customer-container {
  height: 100vh;
  overflow: hidden;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

#main_content.w1200 {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.crm-customer-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.content-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.content-header h1 {
  font-size: 20px;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.stats-bar {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  padding: 12px 16px;
  background-color: #f0f9ff;
  border-radius: 6px;
  margin-bottom: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  color: #909399;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.filter-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.pagination-wrap {
  flex-shrink: 0;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.phone-line {
  line-height: 1.6;
}

.section-title {
  margin-top: 20px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #303133;
}

.remark-form {
  margin-top: 8px;
}
</style>